import {FC} from 'react';
import {ICell, ITest} from '@types';
import {theme} from '@styles/theme';
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {Doughnut} from 'react-chartjs-2';
import {
  CoverageTestChartWrapper,
  CoverageTestFullText,
} from '@molecules/CoverageTestBlock.styles';
import Text from '@atoms/Text';

ChartJS.register(ArcElement, Tooltip, Legend);

export interface CoverageTestBlockProps {
  test?: ITest | ICell;
}

const CoverageChart: FC<CoverageTestBlockProps> = ({test}) => {
  const isCell = test && (test as ICell).auto_coverage !== undefined;
  const autoCoverage = isCell
    ? (test as ICell)?.auto_coverage || 0
    : (test as ITest)?.autoCoverage || 0;
  const manualCoverage = isCell
    ? (test as ICell)?.coverage || 0
    : (test as ITest)?.coverage || 0;
  const emptyCoverage = 100 - autoCoverage - manualCoverage;

  const chartData = {
    datasets: [
      {
        label: '',
        data: [autoCoverage, manualCoverage, emptyCoverage],
        backgroundColor: [
          theme.colors.auto00,
          theme.colors.manual00,
          theme.colors.basic05,
        ],
        offset: 2,
      },
    ],
  };

  const chartOptions = {
    cutout: '75%', // Толщина "бублика" (чем больше %, тем тоньше)
    plugins: {
      legend: {
        display: false, // Скрываем легенду
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            return `${context.label}: ${context.raw}%`;
          },
        },
      },
    },
  };

  return (
    <CoverageTestChartWrapper>
      <Doughnut data={chartData} options={chartOptions} />
      <CoverageTestFullText>
        <Text text={`${autoCoverage + manualCoverage}%`} type="bodyNum" />
      </CoverageTestFullText>
    </CoverageTestChartWrapper>
  );
};

export default CoverageChart;
